module.exports = __webpack_public_path__ + "static/img/am.06509258.svg";